import { useState, useCallback, useEffect } from 'react'
import { api } from '../api/client.js'

export interface ApprovalState {
  id: string
  name: string
}

export interface UseApprovalStatesResult {
  approvalStates: ApprovalState[]
  loading: boolean
  error: string | null
  refetch: () => Promise<void>
}

export function useApprovalStates(): UseApprovalStatesResult {
  const [approvalStates, setApprovalStates] = useState<ApprovalState[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const refetch = useCallback(async (): Promise<void> => {
    setLoading(true)
    setError(null)
    try {
      const res = await api.get<{ approvalStates: ApprovalState[] }>('/admin/conversation-management/approval-states/dropdown')
      setApprovalStates(res.approvalStates || [])
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to fetch approval states')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    void refetch()
  }, [refetch])

  return { approvalStates, loading, error, refetch }
}
